/// <amd-module name="VSSUI/Components/IdentityCard/IdentityCardHeaderElement" />
import * as React from "react";
import * as Resources from "VSSUI/Resources.Persona";

import { Button } from "VSSUI/Button";
import { Icon } from "VSSUI/Icon";
import { Persona } from "../Persona/Persona";
import { PersonaSize } from "../Persona/Persona.Props";
import { HeaderElementProps } from "./IdentityCard.Props";

export class IdentityCardHeaderElement extends React.Component<HeaderElementProps> {
    private personaElement: React.RefObject<Button> = React.createRef<Button>();

    public componentDidMount(): void {
        this.setFocus();
    }

    public componentDidUpdate(): void {
        this.setFocus();
    }

    // Render
    public render(): JSX.Element {
        const { identity } = this.props;
        if (!identity) {
            // Identity is empty in the case of previous
            return <div />;
        }

        return (
            <div className="flex-row scroll-hidden">
                <Button
                    className="bolt-identity-card-go-back-wrapper flex-row flex-grow scroll-hidden"
                    onClick={this.props.onClickFunction}
                    aria-label={Resources.IdentityCardHeaderButtonLabel}
                    ref={this.personaElement}
                    primary={true}
                >
                    <Icon iconName="ChevronLeftMed" />
                    <Persona className="bolt-identity-card-go-back" size={PersonaSize.size24} identity={identity} />
                    <div className="bolt-identity-card-name text-ellipsis">{identity.displayName}</div>
                </Button>
            </div>
        );
    }

    /**
     * Sets the focus on this header.
     */
    private setFocus() {
        if (this.personaElement.current) {
            this.personaElement.current.focus();
        }
    }
}
